module.exports = __webpack_public_path__ + "img/icon-star-empty-yellow.5d4918ef39458774be07328a2222f36d.svg";